import React, { useState, useContext, useEffect } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import ThemeToggle from './ThemeToggle';
import '../styles/profileDrawer.css';

const ProfileDrawer = ({ preferences, setPreferences, onLogout, onDeleteAccount }) => {
  const { isDarkMode } = useContext(ThemeContext);
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  
  useEffect(() => {
    const handleProfileClick = () => {
      setIsOpen(true);
      document.getElementById('profile-drawer').classList.add('open');
      document.getElementById('drawer-overlay').classList.add('visible');
    };
    
    const profileButton = document.querySelector('.profile-button');
    if (profileButton) {
      profileButton.addEventListener('click', handleProfileClick);
    }
    
    return () => {
      if (profileButton) {
        profileButton.removeEventListener('click', handleProfileClick);
      }
    };
  }, []);
  
  const closeDrawer = () => {
    setIsOpen(false);
    setIsDeleteConfirmOpen(false);
    document.getElementById('profile-drawer').classList.remove('open');
    document.getElementById('drawer-overlay').classList.remove('visible');
  };
  
  const handlePreferencesChange = (e) => {
    const text = e.target.value;
    if (text.length <= 1000) {
      setPreferences(text);
    }
  };

  const handleLogout = () => {
    onLogout();
    closeDrawer();
  };

  const handleDeleteAccount = () => {
    if (window.confirm("Are you sure you want to delete your account? This action will unsync all of your synced files and cannot be undone.")) {
      onDeleteAccount();
      closeDrawer();
    }
  };
  
  return (
    <>
      <div 
        id="profile-drawer" 
        className={`profile-drawer ${isDarkMode ? 'dark' : 'light'}`}
      >
        <div className="drawer-header">
          <h2>Profile</h2>
          <button className={`close-button ${isDarkMode ? 'dark' : 'light'}`} onClick={closeDrawer}>×</button>
        </div>
        
        <div className="drawer-content">
          <div className="preferences-section">
            <div className="preferences-section-header">
              <ThemeToggle additionalOnClick={closeDrawer}/>
              <h3>User Preferences</h3>
            </div>
            <p className="char-count">{preferences.length}/1000 characters</p>
            <textarea
              value={preferences}
              onChange={handlePreferencesChange}
              placeholder="Enter your preferences here to customize responses..."
              maxLength={1000}
              className={`preferences-input ${isDarkMode ? 'dark' : 'light'}`}
            />
          </div>
          
          <div className="profile-actions">
            <button 
              className={`profile-action-button logout-button ${isDarkMode ? 'dark' : 'light'}`}
              onClick={handleLogout}
            >
              Logout
            </button>
            
            <button 
              className={`profile-action-button delete-button ${isDarkMode ? 'dark' : 'light'}`}
              onClick={handleDeleteAccount}
            >
              Delete Account
            </button>
          </div>
        </div>
      </div>
      
      <div 
        id="drawer-overlay" 
        className="overlay"
        onClick={closeDrawer}
      ></div>
    </>
  );
};

export default ProfileDrawer;